
import {
  Divider,
  Stack,
  Text,
  Container,
  Box,
  HStack,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Flex,
  Badge,
  Image,
  List,
  ListItem,
  ListIcon,
  // eslint-disable-next-line
  ButtonGroup,
  // eslint-disable-next-line
  Center,
} from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { Fade } from "react-reveal";
import { useEffect, useState } from "react";

export default function Education({ color }) {
  const [education, setEducation] = useState([]);

  useEffect(() => {
    // Fetch Education.md content
    fetch("/content/Education.md")
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch markdown content");
        return response.text();
      })
      .then((mdContent) => {
        // Parse Markdown content into structured data
        const parsedEducation = parseEducation(mdContent);
        setEducation(parsedEducation);
      })
      .catch((error) => {
        console.error("Error fetching education content:", error);
      });
  }, []);

  // Function to parse Education.md
  const parseEducation = (mdContent) => {
    const educationDetails = [];
    const lines = mdContent.split("\n");

    for (let i = 0; i < lines.length; i++) {
      if (lines[i].startsWith("## ")) {
        const institution = lines[i].substr(3).trim();
        const positionLine = lines[++i]
          .substr(2)
          .split("|")
          .map((s) => s.trim());
        const position = positionLine[0].slice(1, -1);
        const duration = positionLine[1];
        const imageLine = lines[++i];
        const image = imageLine.match(/!\[(.*?)\]\((.*?)\)/)[2];
        const tags = lines[++i].split(":")[1].trim();
        const badges = [];
        const listItems = [];

        // Parse List Items
        while (
          lines[++i] &&
          !lines[i].startsWith("- Badges:") &&
          lines[i].startsWith("  - ")
        ) {
          listItems.push(lines[i].substr(4));
        }

        // Parse Badges
        if (lines[i] && lines[i].startsWith("- Badges:")) {
          while (lines[++i] && lines[i].startsWith("  - ")) {
            const badgeLine = lines[i].substr(4).split("[");
            const badgeName = badgeLine[0].trim();
            const badgeColor = badgeLine[1].split("]")[0];
            badges.push({ name: badgeName, colorScheme: badgeColor });
          }
        }

        educationDetails.push({
          image,
          institution,
          position,
          duration,
          badges,
          listItems,
          tags,
        });
      }
    }

    return educationDetails;
  };

  return (
    <Container maxW={"3xl"} id="education">
      <Stack
        as={Box}
        textAlign={"center"}
        spacing={{ base: 8, md: 14 }}
        pb={{ base: 20, md: 36 }}
      >
        <Stack align="center" direction="row" px={4}>
          <HStack mx={4}>
            <Text color={`${color}.400`} fontWeight={800}>
              02
            </Text>
            <Text fontWeight={800}>Education</Text>
          </HStack>
          <Divider orientation="horizontal" />
        </Stack>
        <Stack px={4} spacing={4}>
          {education.map((edu) => (
            <Fade bottom key={edu.institution}>
              <Card size="sm">
                <CardHeader>
                  <Flex justifyContent="space-between">
                    <HStack>
                      <Image src={edu.image} h={50} />
                      <Box px={2} align="left">
                        <Text fontWeight={600}>{edu.institution}</Text>
                        <Text>{edu.position}</Text>
                      </Box>
                    </HStack>
                    <Text px={2} fontWeight={300}>
                      {edu.duration}
                    </Text>
                  </Flex>
                </CardHeader>
                <CardBody>
                  <Flex>
                    <List align="left" spacing={3}>
                      {edu.listItems.map((item, index) => (
                        <ListItem key={index}>
                          <ListIcon
                            boxSize={6}
                            as={ChevronRightIcon}
                            color={`${color}.500`}
                          />
                          {item}
                        </ListItem>
                      ))}
                    </List>
                  </Flex>
                </CardBody>
                <CardFooter>
                  <HStack spacing={2}>
                    {edu.badges.map((badge) => (
                      <Badge key={badge.name} colorScheme={badge.colorScheme}>
                        {badge.name}
                      </Badge>
                    ))}
                  </HStack>
                </CardFooter>
              </Card>
            </Fade>
          ))}
        </Stack>
      </Stack>
    </Container>
  );
}
